import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InsightPicksStyle = styled('div')`
  padding-bottom: 65px;
  ${media.desktop} {
    padding-bottom: 33px;
  }
  .insightpicks {
    &--picks-wrap {
      ${media.mobile} {
        padding: 0 20px;
      }
    }
  }
  .insightpicks--pick {
    cursor: pointer;
  }
  .slick-arrow {
    ${media.mobile} {
      display: none !important;
    }
  }
  .slick-dots {
    ${media.mobile} {
      bottom: -50px;
      margin-left: -15px;
    }
    ${media.desktop} {
      bottom: -2px;
      right: -252px;
    }
    li {
      width: 4px;
      button:before {
        font-size: 40px;
      }
    }
  }
`;

export default InsightPicksStyle;
